import React from "react"
import { Link } from "react-router"
import FontAwesome from "react-fontawesome"

import "./styles.css"

export default function SidebarItem({ to, icon, children, title }){
  return (
    <li className="sidebarItem" title={ title }>
      <Link to={ to } activeClassName="active">
        <span className="sidebar-item-icon-container">
          <FontAwesome name={ icon } size="lg" />
        </span>
        <span>
          { children }
        </span>
      </Link>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarItem.js